import React, { useEffect } from 'react';
import FAQs from './page/FAQ';
import Terms from './page/Terms'
import TermsApp from './page/TermsApp'
import PolicyApp from './page/PolicyApp'
import Policy from './page/Policy'
import Home from './page/Home'
import About from './page/About'
import HelpCenter from './page/HelpCenter'
import Contact from './page/Contact'
import News from './page/News'
import Partners from './page/Partners'
import PartnerApplication from './page/PartnerApplication'
import {
  BrowserRouter,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import './STablet.css';
import './LTablet.css';
import './SLaptop.css';
import './LMonitor.css';
import './XLMonitor.css';

function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const element = document.querySelector(hash);
      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "start" });
      }
      return;
    }

    window.scrollTo({ top: 0, left: 0 });
  }, [pathname, hash]);

  return null;
}

function App() {
  

  return (
  <BrowserRouter basename="/">
    <div className="App">
      <ScrollToTop />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about-us" element={<About />} />
        <Route path="/help-center" element={<HelpCenter />} />
        <Route path="/contact-us" element={<Contact />} />
        <Route path="/news" element={<News />} />
        <Route path="/partners" element={<Partners />} />
        <Route path="/partners/apply" element={<PartnerApplication />} />
        <Route path="/faqs" element={<FAQs />} />
        <Route path="/terms-and-conditions" element={<Terms />} />
        <Route path="/privacy-policy" element={<Policy />} />
        <Route path="/terms/app" element={<TermsApp />} />
        <Route path="/policy/app" element={<PolicyApp />} />
      </Routes>
    </div>
  </BrowserRouter>
  );
}

export default App;
